<template>
  <div :class="[baseCss]">
    <ul :class="['barebone-list', 'inline-list', `text-${align}`]">
      <li v-if="firstLastButtons">
        <btn
          @click="onBtnClick(0)"
          :disabled="page === 0"
          :size="size"
          :flat="flat"
          :rounded="rounded"
          :class="[dense ? 'm-0.5' : 'm-1']"
          :elevation="elevation"
          :bg-color="bgColor"
          :bg-color-lightness="bgColorLightness">
          <icon :provider="iconProvider" name="chevron-double-left" :color="color" :color-lightness="colorLightness" />
        </btn>
      </li><li v-if="prevNextButtons">
        <btn
          @click="onBtnClick(page - 1)"
          :disabled="page === 0"
          :size="size"
          :flat="flat"
          :rounded="rounded"
          :class="[dense ? 'm-0.5' : 'm-1']"
          :elevation="elevation"
          :bg-color="bgColor"
          :bg-color-lightness="bgColorLightness">
          <icon :provider="iconProvider" name="chevron-left" :color="color" :color-lightness="colorLightness" />
        </btn>
      </li><li v-for="(item, index) in count" :key="index" v-if="pageButtons">
        <btn
          @click="onBtnClick(index)"
          :size="size"
          :title="page"
          :flat="flat"
          :rounded="rounded"
          :class="[dense ? 'm-0.5' : 'm-1', index === page ? 'pointer-events-none' : null]"
          :elevation="elevation"
          :color="index === page ? selectedColor : color"
          :color-lightness="index === page ? selectedColorLightness : colorLightness"
          :bg-color="index === page ? selectedBgColor : bgColor"
          :bg-color-lightness="index === page ? selectedBgColorLightness : bgColorLightness">{{ item }}</btn>
      </li><li v-if="prevNextButtons">
        <btn
          @click="onBtnClick(page + 1)"
          :disabled="page === count - 1"
          :size="size"
          :flat="flat"
          :rounded="rounded"
          :class="[dense ? 'm-0.5' : 'm-1']"
          :elevation="elevation"
          :bg-color="bgColor"
          :bg-color-lightness="bgColorLightness">
          <icon :provider="iconProvider" name="chevron-right" :color="color" :color-lightness="colorLightness" />
        </btn>
      </li><li v-if="firstLastButtons">
        <btn
          @click="onBtnClick(count - 1)"
          :disabled="page === count - 1"
          :size="size"
          :flat="flat"
          :rounded="rounded"
          :class="[dense ? 'm-0.5' : 'm-1']"
          :elevation="elevation"
          :bg-color="bgColor"
          :bg-color-lightness="bgColorLightness">
          <icon :provider="iconProvider" name="chevron-double-right" :color="color" :color-lightness="colorLightness" />
        </btn>
      </li>
    </ul>
  </div>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'
import Utils from '../../mixins/utils'

export default {
  name: 'Pager',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('pager', ['select-none'])
    }
  },
  model: {
    prop: 'page',
    event: 'input'
  },
  props: {
    page: {
      type: Number
    },
    value: 0,
    align: {
      type: String,
      default: 'left',
      validator: value => {
        return ['left', 'center', 'right', 'auto'].includes(value)
      }
    },
    count: {
      type: Number
    },
    dense: {
      type: Boolean
    },
    prevNextButtons: {
      type: Boolean,
      default: true
    },
    pageButtons: {
      type: Boolean,
      default: true
    },
    flat: {
      type: Boolean
    },
    rounded: {
      type: Boolean,
      default: true
    },
    firstLastButtons: {
      type: Boolean,
      default: true
    },
    bgColor: {
      type: String
    },
    bgColorLightness: {
      type: [Number, String],
      validator: value => {
        const utils = new Utils()
        return utils.validateLightness(value)
      }
    },
    selectedColor: {
      default: 'white'
    },
    selectedColorLightness: {
      type: [Number, String],
      validator: value => {
        const utils = new Utils()
        return utils.validateLightness(value)
      }
    },
    selectedBgColor: {
      type: String,
      default: 'gray'
    },
    selectedBgColorLightness: {
      type: [Number, String],
      default: 600,
      validator: value => {
        const utils = new Utils()
        return utils.validateLightness(value)
      }
    },
    color: {
      default: 'gray'
    },
    size: {
      type: String,
      default: 'sm',
      validator: value => {
        return ['xs', 'sm', 'base', 'lg', 'xl'].includes(value)
      }
    }
  },
  methods: {
    onBtnClick ($event) {
      const page = this.page
      if (page !== $event) {
        this.$emit('input', page < $event ? $event++ : $event--)
      }
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/pager/pager.vue